import { render, staticRenderFns } from "./TextResponsePanel.vue?vue&type=template&id=6215f909&scoped=true"
import script from "./TextResponsePanel.vue?vue&type=script&lang=js"
export * from "./TextResponsePanel.vue?vue&type=script&lang=js"
import style0 from "./TextResponsePanel.vue?vue&type=style&index=0&id=6215f909&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6215f909",
  null
  
)

export default component.exports